<template>
  <div class="fts-form-skip-confirmation">
    <div
      v-for="queue in queueList"
      :key="queue.id"
      class="form-skip-confirmation-wrapper"
    >
      <div>
        Performing {{queue.payload.activity && queue.payload.activity.name || 'activity'}}...
      </div>
      <fts-btn
        sm
        text
        text-transform-init
        class="form-skip-confirmation-action fts-font-normal"
        @click="undoItem(queue)"
      >
        undo
      </fts-btn>
    </div>
  </div>
</template>

<script>
import commons from '../../commons/commons';
import { classificationStore } from '../../store/classificationStore';

import FTSBtn from '../FTSBtn';

export default {
  components: {
    'fts-btn': FTSBtn
  },
  data: () => ({
    queueList: []
  }),
  methods: {
    addQueue(payload) {
      const item = {
        id: commons.nanoID(),
        payload: payload,
        timeRemaining: 2,
        intervalId: null,
      };

      item.intervalId = setInterval(() => {
        item.timeRemaining--;
        if (item.timeRemaining <= 0) {
          this.executeItem(item);
        }
      }, 1000);

      this.queueList.push(item);
    },
    async executeItem(item) {
      clearInterval(item.intervalId);
      const index = this.queueList.indexOf(item);
      if (index !== -1) {
        this.queueList.splice(index, 1);
      }
      try {
        await classificationStore.dispatch("submitActivity", {
          moduleId: item.payload.moduleId,
          activityId: item.payload.activityId,
          entryIds: item.payload.entryIds
        });
        this.$toasted.success("Submission successful", {
          duration: 2000,
          singleton: true
        });
        window.eventBus.$emit("entry:updated", {
          moduleId: item.payload.moduleId,
          preserveSelectedEntries: true 
        });
      } catch(err) {
        console.error(err);
        this.$toasted.error(`Failed to perform ${item.payload.activity && item.payload.activity.name}`)
      }
    },
    undoItem(item) {
      clearInterval(item.intervalId);
      const index = this.queueList.indexOf(item);
      if (index !== -1) {
        this.queueList.splice(index, 1);
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-form-skip-confirmation {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1080;
  display: flex;
  flex-direction: column-reverse;
  .form-skip-confirmation-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    border: 1px solid var(--fts-border);
    border-radius: 0.375rem;
    box-shadow: var(--fts-elevation-3);
    background-color: var(--fts-gray-900);
    font-size: 0.875rem;
    line-height: 1.75rem;
    color: var(--fts-gray-200);
    & + .form-skip-confirmation-wrapper {
      margin-bottom: 0.5rem;
    }
  }
  .form-skip-confirmation-action {
    margin-left: 1rem;
  }
}
</style>